// extracted by mini-css-extract-plugin
module.exports = {"details":"Detail_details__1iwrJ","btnPrimaryBack":"Detail_btnPrimaryBack__3S-48","button":"Detail_button__SGTlj"};